import { BodyField } from './Fields/BodyField';
import { IUseLiveMeetingResponse } from '../useLiveMeeting';
import { MeetingInProgressFormController } from './FormController';
import { AddResolutionButton } from '../Header/AddResolutionButton';
import { RecordVote } from '../Header/RecordVote';
import { TopicTitle } from '../Header/TopicTitle';
import { Box } from '@mui/material';

interface IResolutionFields {
  liveMeeting: IUseLiveMeetingResponse;
}

export const ResolutionFields: React.FC<IResolutionFields> = (props) => {
  return (
    <MeetingInProgressFormController liveMeeting={props.liveMeeting}>
      <TopicTitle liveMeeting={props.liveMeeting} />
      <RecordVote liveMeeting={props.liveMeeting} />
      <BodyField />
      <Box>
        <AddResolutionButton liveMeeting={props.liveMeeting} />
      </Box>
    </MeetingInProgressFormController>
  );
};
